import React from 'react';
import LinkWithQuery from '../LinkWithQuery';
import { fpqUrl } from '../../utils/variables';

const MobileHeader = ({ mobileMenuOpen, activeMobileMenuId, handleMobileMenuSelect }) => {
	return (
		<div className={`c-mobile-menu u-desktop-hidden ${mobileMenuOpen ? 'burger-is-active' : ''}`}>
			<a className="c-mobile-menu__title c-mobile-menu__title--cta track-cta-mobile-nav" href={fpqUrl}>
				<span>Check If You Qualify</span>
			</a>
			<ul className="c-mobile-menu__items">
				<li className={`c-mobile-menu__item ${activeMobileMenuId === 'Hearing-Aids' ? 'is-open' : ''}`}>
					<button className="c-mobile-menu__title" onClick={handleMobileMenuSelect} data-header-menu-id="Hearing-Aids">
						Hearing Aids
						<svg className="c-mobile-menu__caret" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 312.3 578.5">
							<path d="M46.7 1.2c4.5 0 8.6 1.9 12.1 5.8L304 276c3.5 3.9 5.3 8.3 5.3 13.3s-1.8 9.4-5.3 13.3l-245.2 269c-3.5 3.8-7.5 5.8-12.1 5.8s-8.6-1.9-12.1-5.8L8.3 542.7c-3.5-3.9-5.3-8.3-5.3-13.3 0-5.1 1.8-9.4 5.3-13.3l206.8-226.9L8.3 62.4C4.8 58.5 3 54.1 3 49.1s1.8-9.4 5.3-13.3L34.6 7c3.5-3.9 7.6-5.9 12.1-5.8z"></path>
						</svg>
					</button>
					<ul
						className="c-mobile-menu__sub-items"
						style={{ display: activeMobileMenuId === 'Hearing-Aids' ? 'block' : 'none' }}
					>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-aids/horizon/">
								Horizon Hearing Aids
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-aids/">
								Hearing Aids
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-aids/prices/">
								Prices
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-aids/technology/">
								Technology
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-aids/brands/">
								Manufacturers
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/resources/hearing-aids/guide-to-price-value/">
								How to Choose A Hearing Aid
							</LinkWithQuery>
						</li>
					</ul>
				</li>
				<li className={`c-mobile-menu__item ${activeMobileMenuId === 'Hearing-Loss' ? 'is-open' : ''}`}>
					<button className="c-mobile-menu__title" onClick={handleMobileMenuSelect} data-header-menu-id="Hearing-Loss">
						Hearing Loss
						<svg className="c-mobile-menu__caret" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 312.3 578.5">
							<path d="M46.7 1.2c4.5 0 8.6 1.9 12.1 5.8L304 276c3.5 3.9 5.3 8.3 5.3 13.3s-1.8 9.4-5.3 13.3l-245.2 269c-3.5 3.8-7.5 5.8-12.1 5.8s-8.6-1.9-12.1-5.8L8.3 542.7c-3.5-3.9-5.3-8.3-5.3-13.3 0-5.1 1.8-9.4 5.3-13.3l206.8-226.9L8.3 62.4C4.8 58.5 3 54.1 3 49.1s1.8-9.4 5.3-13.3L34.6 7c3.5-3.9 7.6-5.9 12.1-5.8z"></path>
						</svg>
					</button>
					<ul
						className="c-mobile-menu__sub-items"
						style={{ display: activeMobileMenuId === 'Hearing-Loss' ? 'block' : 'none' }}
					>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-loss/">
								Hearing Loss
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-loss/symptoms/">
								Symptoms
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-loss/sudden/">
								Sudden
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-loss/sensorineural/">
								Sensorineural
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-loss/conductive/">
								Conductive
							</LinkWithQuery>
						</li>
					</ul>
				</li>
				<li className={`c-mobile-menu__item ${activeMobileMenuId === 'Resources' ? 'is-open' : ''}`}>
					<button className="c-mobile-menu__title" onClick={handleMobileMenuSelect} data-header-menu-id="Resources">
						Resources
						<svg className="c-mobile-menu__caret" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 312.3 578.5">
							<path d="M46.7 1.2c4.5 0 8.6 1.9 12.1 5.8L304 276c3.5 3.9 5.3 8.3 5.3 13.3s-1.8 9.4-5.3 13.3l-245.2 269c-3.5 3.8-7.5 5.8-12.1 5.8s-8.6-1.9-12.1-5.8L8.3 542.7c-3.5-3.9-5.3-8.3-5.3-13.3 0-5.1 1.8-9.4 5.3-13.3l206.8-226.9L8.3 62.4C4.8 58.5 3 54.1 3 49.1s1.8-9.4 5.3-13.3L34.6 7c3.5-3.9 7.6-5.9 12.1-5.8z"></path>
						</svg>
					</button>
					<ul
						className="c-mobile-menu__sub-items"
						style={{ display: activeMobileMenuId === 'Resources' ? 'block' : 'none' }}
					>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/resources/hearing-loss/">
								Hearing Loss
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/resources/hearing-aids/">
								Hearing Aids
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/resources/hearing-aid-success/">
								Hearing Aids Success
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/faqs/">
								FAQ
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/hearing-test/">
								Hearing Test
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/resources/videos/">
								Videos
							</LinkWithQuery>
						</li>
					</ul>
				</li>
				<li className={`c-mobile-menu__item ${activeMobileMenuId === 'About-Us' ? 'is-open' : ''}`}>
					<button className="c-mobile-menu__title" onClick={handleMobileMenuSelect} data-header-menu-id="About-Us">
						About Us
						<svg className="c-mobile-menu__caret" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 312.3 578.5">
							<path d="M46.7 1.2c4.5 0 8.6 1.9 12.1 5.8L304 276c3.5 3.9 5.3 8.3 5.3 13.3s-1.8 9.4-5.3 13.3l-245.2 269c-3.5 3.8-7.5 5.8-12.1 5.8s-8.6-1.9-12.1-5.8L8.3 542.7c-3.5-3.9-5.3-8.3-5.3-13.3 0-5.1 1.8-9.4 5.3-13.3l206.8-226.9L8.3 62.4C4.8 58.5 3 54.1 3 49.1s1.8-9.4 5.3-13.3L34.6 7c3.5-3.9 7.6-5.9 12.1-5.8z"></path>
						</svg>
					</button>
					<ul
						className="c-mobile-menu__sub-items"
						style={{ display: activeMobileMenuId === 'About-Us' ? 'block' : 'none' }}
					>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/about-us/why-hear/">
								Why hear.com
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/about-us/how-it-works/">
								How It Works
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/about-us/network/">
								Our Network
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/about-us/testimonials/">
								Testimonials
							</LinkWithQuery>
						</li>
						<li className="c-mobile-menu__sub-item">
							<LinkWithQuery className="c-mobile-menu__link" to="/about-us/awards/">
								Awards
							</LinkWithQuery>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	);
};

export default MobileHeader;
